<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <ckeditor
          :editor="editor"
          v-model="editorData"
          :config="editorConfig"
        ></ckeditor>
      </div>
      <div class="col-12 mt-2">
        <button
          class="btn btn-primary btn-sm float-end"
          @click="saveInfo"
          v-if="isWrite || isWrite == 1"
        >
          <i class="fa fa-save me-1"></i> Simpan
        </button>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Informasi Ujian",
      isWrite: localStorage.getItem("isWrite"),
      idInfoUjian: this.$route.params.id,
      infoUjian: {},
      editor: ClassicEditor,
      editorData: "<p>Tambah informasi ujian disini.</p>",
      editorConfig: {
        toolbar: [
          "heading",
          "|",
          "bold",
          "italic",
          "link",
          "bulletedList",
          "numberedList",
          "|",
          "outdent",
          "indent",
          "|",
          "blockQuote",
          "insertTable",
          "undo",
          "redo",
        ],
      },
    };
  },
  methods: {
    async getInfo() {
      const data = await axios({
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "info-ujian/" +
          this.idInfoUjian,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`
        },
      }).then((response) => response.data.data);
      if (data) {
        this.editorData = data.info_ujian;
        this.infoUjian = data;
      }
    },
    async saveInfo() {
      Swal.fire({
        icon: "warning",
        title: "Apakah Anda yakin menyimpan data Informasi Ujian ini ?",
        showCancelButton: true,
        confirmButtonText: "Ya, Saya yakin!",
        cancelButtonText: "Batal",
      }).then(async (result) => {
        if (result.isConfirmed) {
          let method = this.idInfoUjian ? "put" : "post";
          let url = this.idInfoUjian
            ? `info-ujian/${this.idInfoUjian}`
            : `info-ujian`;
          let payload = {
            info_ujian: this.editorData,
            type: 'dummy',
          };
          if (this.idInfoUjian) {
            payload.active_flag = this.infoUjian.active_flag;
          }

          const data = await axios({
            method: method,
            url: process.env.VUE_APP_BACKEND_URL_VERSION + url,
            data: payload,
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          }).then((response) => response.data.data);
          if (data) {
            await Swal.fire({
              icon: "success",
              title: "Berhasil",
              text: "Data berhasil disimpan",
              timer: 2000,
              timerProgressBar: true,
            });
            this.$router.push({ name: "info-ujian-demo" });
          }
        }
      });
    },
  },
  async mounted() {
    this.idInfoUjian = this.$route.params.id;
    if (this.idInfoUjian) {
      await this.getInfo();
    }
  },
};
</script>

<style></style>
